<template>
	<div class="b-request b-form">
		<h3 class="b-section__title b-form__title" v-if="formTitle" v-html="formTitle"></h3>
		<el-form ref="formData"
		         class="form form_request b-form b-form_request"
		         :model="formData"
		         :rules="rules"
		         label-position="top"
		>
			<div class="b-form__inside" v-if="formFields && formFields.length > 0">
				<div v-if="product" class="b-form__preview b-form__preview_product b-form__product">
					<div v-if="product.picture.src" class="b-form__product-imgWrap">
						<img :src="product.picture.src" class="b-form__product-img"/>
					</div>
					<div class="b-form__product-content">
						<div class="b-form__product-name" v-html="product.name"></div>
						<div class="b-form__product-price" v-if="product.price && product.price.price > 0" v-html="product.price.hasOwnProperty('price_formatted') ? product.price.price_formatted : product.price.price"></div>
					</div>
				</div>
				<el-row :gutter="30" class="el-row_flex">
					<el-col v-for="group in formFields.filter(group => group.HIDDEN !== true)"
					        :key="group.CODE"
					        :span="24"
					        :sm="12"
					        :style="{gridArea: group.CODE}"
					>
						<div v-if="group.GROUP_FIELD" class="el-block">
							<h4 v-if="group.TITLE" class="el-subtitle"
							    :class="{'el-subtitle_error' : errorGroups.includes(group.CODE)}">
								<span v-html="group.TITLE"></span>
								<i class="fa fa-angle-down el-spoiler" @click.stop="toggleContent($event)"></i>
							</h4>
							<el-row :gutter="30" :class="{'el-row_docs' : group.CODE == 'group_files'}">
								<el-col v-if="group.PLACEHOLDER">
									<div class="el-group__descr" v-html="group.PLACEHOLDER"></div>
								</el-col>
								<el-col v-for="field in group.ITEMS.filter(field => field.HIDDEN !== true)"
								        :key="field.CODE"
								>
									<el-form-item :prop="field.CODE" :label="field.TITLE" ref="formItem">
										<el-upload
											v-if="field.TYPE == 'file'"
											ref="uploadRef"
											action="#"
											:auto-upload="false"
											:multiple="field.MULTIPLE"
											:on-change="getFileChangeCallback(field)"
											:on-remove="getFileRemoveCallback(field)"
											:limit="getFileLimit(field)"
											list-type="picture"
											:class="{'is-error': fileErrors[field.CODE]}"
										>
											<template #trigger>
												<button class="b-btn b-btn_primary b-btn_small"
												        type="button"
												           v-html="field.PLACEHOLDER ? field.PLACEHOLDER : (getFileLimit(field) > 1 ? 'Выберите файлы (' + getFileLimit(field) + ')' : 'Выберите файл')"></button>
											</template>
											<div class="el-form-item__error"
											     v-html="fileErrors[field.CODE]"></div>
										</el-upload>

										<el-rate v-else-if="field.TYPE == 'rating'"
											v-model="formData[field.CODE]"
											@change="onValidateField(field.CODE)"
											:allow-half="false"
											:colors="colors"
											class="el-rate_active"
										></el-rate>

										<el-select v-else-if="field.TYPE == 'list'"
										           v-model="formData[field.CODE]"
										           :placeholder="field.PLACEHOLDER"
										           :multiple="field.MULTIPLE"
										           @change="getErrorFields()"
										>
											<el-option
												v-for="item in field.VALUES"
												:key="item.ID"
												:label="item.VALUE"
												:value="item.ID"
												class="ffffff"
											/>
										</el-select>

										<el-date-picker v-else-if="field.TYPE == 'date'"
										                v-model="formData[field.CODE]"
										                :placeholder="field.PLACEHOLDER"
										                :type="field.TYPE"
										                :format="'dd.MM.yyyy'"
										                :value-format="'dd.MM.yyyy'"
										                @change="getErrorFields()"
										/>

										<el-checkbox-group v-else-if="field.TYPE == 'checkbox'"
										                   v-model="formData[field.CODE]"
										                   @change="getErrorFields()"
										>
											<el-checkbox
												v-for="item in field.VALUES"
												:key="item.ID"
												:label="item.ID"
												:name="field.CODE"
											>{{ item.VALUE }}
											</el-checkbox>
										</el-checkbox-group>

										<el-radio-group v-else-if="field.TYPE == 'radio'"
										                   v-model="formData[field.CODE]"
										                   @change="getErrorFields()"
										>
											<el-radio
												v-for="item in field.VALUES"
												:key="item.ID"
												:label="item.ID"
												:name="field.CODE"
											>{{ item.VALUE }}
											</el-radio>
										</el-radio-group>

										<el-input v-else-if="field.TYPE == 'phone'"
										          v-model="formData[field.CODE]"
										          :placeholder="field.PLACEHOLDER"
										          v-phone-mask
										          type="text"
										          @change="getErrorFields()"
										/>

										<el-input v-else v-model="formData[field.CODE]"
										          :placeholder="field.PLACEHOLDER"
										          :type="field.TYPE"
										          :autosize="field.TYPE == 'textarea'"
										          @change="getErrorFields()"
										/>
									</el-form-item>
								</el-col>
							</el-row>
						</div>
						<el-form-item v-else :prop="field.CODE">
							<el-input v-model="formData[field.CODE]"
							          :placeholder="field.PLACEHOLDER || (field.TITLE)"
							          :type="field.TYPE"
							          :autosize="field.TYPE == 'textarea'"
							          @change="getErrorFields()"
							/>
						</el-form-item>
					</el-col>

					<el-col style="grid-area: footer">
						<el-alert v-if="formDescription" type="info" :closable="false" :title="'Внимание!'"
						          class="el-info">
							<div v-html="formDescription"></div>
						</el-alert>

						<div class="el-form-block el-form-block-agreement b-request__section b-request__section_pb_0"
						     v-if="agreement">
							<el-form-item :prop="agreement.CODE" :label="loc.CITRUS_IBLOCK_ELEMENT_AGREEMENT"
							              ref="formItemAgreement">
								<el-checkbox-group v-model="formData[agreement.CODE]" @change="getErrorFields()">
									<el-checkbox :name="agreement.CODE" label="Y" class="el-checkbox_agreement"
									             style="white-space: normal;">
										<span v-html="agreement.TITLE"></span>
									</el-checkbox>
								</el-checkbox-group>
							</el-form-item>
						</div>
						<ReCaptcha v-if="hasCaptcha" @token="fillRecaptchaToken" ref="recaptcha"/>
						<div class="el-form-footer el-form-footer_center">
							<el-button class="b-btn b-btn_primary b-btn_large"
							           :class="{'b-btn_loading': true === loading}"
							           @click="sendForm"
							           v-html="submitText || loc.CITRUS_VOTING_BTN_SUBMIT"
							></el-button>
						</div>
					</el-col>
				</el-row>
			</div>
		</el-form>
	</div>
</template>

<script>
export default {
	name: "IblockElement",
	mixins: [CitrusUi.FormMixin],
	props: {
		product: {
			type: [Object, null],
			default: null,
		}
	},
	computed: {
		loc() {
			return CitrusUi.getFilteredPhrases("CITRUS_IBLOCK_ELEMENT_");
		},
	},
}
</script>
